// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/layout/Tertiary.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/layout/Tertiary.tsx");
  import.meta.hot.lastModified = "1732036225883.3606";
}
// REMIX HMR END

import { ContentWrapper, CTA } from "~/components";
import { SocialShare } from "../static";
import ToC from "./ToC";
export default function Tertiary({
  node,
  children
}) {
  return <ToC node={node} layout="tertiary">
            <div id="toc-content">
                {children}
            </div>
            <div className="block lg:hidden">
                <SocialShare alignment="primary" />
            </div>
            {node.cta && <div className="block lg:hidden">
                    <ContentWrapper className="bg-neutral-100 pt-14" spacing="tertiary">
                        <CTA {...node.cta} />
                    </ContentWrapper>
                </div>}
        </ToC>;
}
_c = Tertiary;
var _c;
$RefreshReg$(_c, "Tertiary");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;